import React from 'react';
import styles from './PageTabs.module.css';

const PageTabs = (props) => <div className={styles.pageTabs}>{props.children}</div>;

export default PageTabs;
